import { Toolbar as MuiToolbar, ToolbarProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { ToolbarProps };

export const Toolbar: React.ComponentType<ToolbarProps> = styled(MuiToolbar)<ToolbarProps>(
  () => ({}),
);
